import { FeatureCollection, MultiPolygon, Polygon } from 'src/common-services/types/geojson-types'
import z from 'zod'

export enum DriveTimeTypes {
  ARRIVAL = 'A',
  DEPARTURE = 'D',
}

export enum DriveTimeTransportationType {
  DRIVING = 'driving',
  WALKING = 'walking',
  PUBLIC_TRANSPORT = 'public_transport',
}

export enum Day {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export enum DriveTimePolygonsResolution {
  LOWEST = 'lowest',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  HIGHEST = 'highest',
}

export const driveTimeRequestSchema = z.object({
  position: z.array(z.number(), z.number()),
  durations: z.array(z.number()),
  type: z.enum(['driving']),
  direction: z.enum(['departing', 'arriving']),
})

export type GetDriveTimePolygonsRequest = {
  lat: number
  lng: number
  type: DriveTimeTypes
  durations: number[]
  day: Day
  hour: number // 0-23
  resolution?: DriveTimePolygonsResolution
  simplify?: boolean
  transportation: {
    type: DriveTimeTransportationType
  }
}

export type GetDriveTimePolygonsResponse = FeatureCollection<Polygon | MultiPolygon>
